import { AutoMap } from "@automapper/classes";


export class ZoneSamplingConditionDTO {
    @AutoMap()
    vitesseVent!: number;
    @AutoMap()
    meteo!: number;
    @AutoMap()
    hygrometrie!: number;
    @AutoMap()
    expositionClimatique!: number;
}